import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PlatformsType, PLATFORMS } from '../../core';

import { Android as AndroidIcon, Apple as AppleIcon } from '../../icons';
import PlatformButton from '../PlatformButton';

import styles from './ARChoiceModal.module.scss';
import Modal, { ModalProps } from '../Modal';

export type ARChoiceModalProps = Omit<ModalProps, 'title' | 'btnClose' | 'close' | 'isVisible'>;

export type OpenArChoiceModalType = ARChoiceModalProps & {
  resolve: (platform?: PlatformsType | PromiseLike<PlatformsType>) => void;
  reject: (reason?: any) => void;
};

export type OpenArChoiceModalListenerType = (args: OpenArChoiceModalType) => void;

let listener: OpenArChoiceModalListenerType | null = null;

export type OnCloseArChoiceModalCallbackCallback = (platform?: PlatformsType) => void;

const setListener = (callback: OpenArChoiceModalListenerType) => {
  listener = callback;
  return removeListener;
};

const removeListener = () => {
  listener = null;
};

export const openArChoiceModal = (opts?: ARChoiceModalProps) =>
  new Promise<PlatformsType>((resolve, reject) => {
    listener && listener({ cssClass: opts?.cssClass, resolve: resolve as any, reject });
  });

const ARChoiceModal: React.FC = () => {
  const [t] = useTranslation();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [closeModal, setCloseModal] = useState<OnCloseArChoiceModalCallbackCallback>(() => {});

  const onUnMount = setListener(({ cssClass, resolve, reject }: OpenArChoiceModalType) => {
    setIsVisible(true);
    const close = (platform?: PlatformsType) => {
      setIsVisible(false);
      resolve(platform);
    };
    setCloseModal(() => close);
  });

  useEffect(() => {
    return () => {
      onUnMount();
    };
  }, [onUnMount]);

  const onPlatformSelect = (platform?: PlatformsType) => {
    closeModal(platform);
  };
  return (
    <Modal title={t('AR_MODAL_TITLE')} btnClose={t('X')} isVisible={isVisible} cssClass={styles.ff_ar_choice_modal} close={closeModal}>
      <div data-testid='ar-choice-modal' className={styles.ff_ar_choice_modal_content}>
        <div className={classNames(styles.ff_ar_choice_modal_content__platform, 'android')}>
          <PlatformButton onClick={() => onPlatformSelect(PLATFORMS.Android)}>
            <AndroidIcon />
          </PlatformButton>
        </div>
        <div className={classNames('ios', styles.ff_ar_choice_modal_content__platform)}>
          <PlatformButton onClick={() => onPlatformSelect(PLATFORMS.iOS)}>
            <AppleIcon />
          </PlatformButton>
        </div>
      </div>
    </Modal>
  );
};

export default ARChoiceModal;
